import Swal from 'sweetalert2';
import { deleteProject } from "../../../api/projectAPI";

export const handleDeleteProject = async (
  id,
  projects,
  setProjects
) => {
  const confirmation = await Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  try {
    Swal.fire({
      title: 'Deleting...',
      text: 'Please wait while we delete the project.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    await deleteProject(id);

    setProjects(projects.filter((project) => project.id !== id));

    Swal.fire({
      icon: 'success',
      title: 'Deleted!',
      text: 'Project has been deleted.',
    });
  } catch (error) {
    console.error("Error deleting project:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to delete project.',
    });
  }
};
